export const QA_NAME_POST_CREATION_MODAL = 'create_post'
